import store from '../store'

export function addExportToQueue(group, queryParameters) {
    //window.console.log("## helpers\sevices@exportData ")
    //window.console.log("Group: " + group)
    //window.console.log("Query parameters:")
    //window.console.log(queryParameters)

    store.commit('SET_PROGRESS', true)
    store.commit('SET_LOADER_TEXT', 'Izvoz podatkov je v teku...')
    store.commit('SET_LOADER', true)
    
    store.dispatch('EXPORT', {
        group: group,
        queryParameters: queryParameters
    })
    .then(response => {
        //window.console.log(response)

        store.commit('SET_SNACKBAR_DISPLAY', false)
        //store.commit('snackbarText', "Export is added to queue. Wait to get your file soon.")
        store.commit('SET_SNACKBAR_TEXT', "Izvoz podatkov je v teku. Dokument z izvoženimi podatki najdete na seznamu na strani 'Izvoz podatkov'.")
        store.commit('SET_SNACKBAR_MODE', '')
        store.commit('SET_SNACKBAR_TIMEOUT', 7000)
        store.commit('SET_SNACKBAR_MODE', 'multi-line')
        store.commit('SET_SNACKBAR_DISPLAY', true)
    
    })
    .catch(error => {
        window.console.log('CREATE RFID USER error')
        window.console.log(error)
        store.commit('SET_SNACKBAR_DISPLAY', false)
        store.commit('SET_SNACKBAR_MODE', 'multi-line')
        store.commit('SET_SNACKBAR_TEXT', 'Pri izvozu podatkov je prišlo do napake. Prosimo poskusite ponovno.')
        store.commit('SET_SNACKBAR_MODE', 'multi-line')
        store.commit('SET_SNACKBAR_DISPLAY', true)
    })
    .finally(() => {
        setTimeout(() =>{
            store.commit('SET_PROGRESS', false)
            store.commit('SET_LOADER', false)
            store.commit('SET_LOADER_TEXT', '')
            store.commit('SET_SNACKBAR_MODE', '')
        },600)
    })
}

export function snackbarMessage(settings) {
    store.commit('SET_SNACKBAR_DISPLAY', false)
    store.commit('SET_SNACKBAR_TEXT', settings.text)
    store.commit('SET_SNACKBAR_MODE', '')
    store.commit('SET_SNACKBAR_TIMEOUT', settings.timeout)
    store.commit('SET_SNACKBAR_MODE', settings.mode)
    store.commit('SET_SNACKBAR_DISPLAY', true)
}



export default {
    addExportToQueue
}